module.exports = __webpack_public_path__ + "img/5.821d658c.jpg";